import React from 'react';
import { TabPanel } from '../../components/ui/index.jsx';
import { ToastProvider } from '../../components/ui/Toast.jsx';
import '../../scss/main.scss';
import {
  GeneralSettingTab,
  TranslationsTab,
  RegistrationFormSettingsTab,
  NewUserRegistrationTab,
  AdminEmailSettingTab,
  NotificationTab,
  UserManagementTab,
} from './Tabs';

const App = () => (
  <ToastProvider>
    <div className="plugin-settings">

      <div className="bpsfw-page-header">
        <div className="bpsfw-page-header__left">
          <div className="bpsfw-page-header__meta">
            <h1 className="bpsfw-page-header__title">Build Private Store For WooCommerce</h1>
            <p className="bpsfw-page-header__sub">Access control · Registration · Notifications</p>
          </div>
        </div>
        <div className="bpsfw-page-header__actions">
          <a href="https://www.plugin999.com/support/" target="_blank" rel="noreferrer"
             className="bpsfw-header-btn bpsfw-header-btn--outline">💬 Support</a>
          <a href="https://wordpress.org/support/plugin/build-private-store-for-woocommerce/reviews/"
             target="_blank" rel="noreferrer"
             className="bpsfw-header-btn bpsfw-header-btn--star">★ Rate Plugin</a>
          <a href="https://www.plugin999.com/plugin/build-private-store-for-woocommerce/"
             target="_blank" rel="noreferrer"
             className="bpsfw-header-btn bpsfw-header-btn--pro">⚡ Go Pro</a>
        </div>
      </div>

      <TabPanel
        className="bpsfw-tab-panel--main"
        activeClass="is-active"
        tabs={[
          { name: 'general',    title: '⚙️  General',       className: 'tab-general' },
          { name: 'translations', title: '🌐  Translations',  className: 'tab-translations' },
          { name: 'newUsers',   title: '👤  New Users',      className: 'tab-newusers' },
          { name: 'adminEmail', title: '📧  Admin Email',    className: 'tab-adminemail' },
          { name: 'notify',     title: '🔔  Notifications',  className: 'tab-notify' },
          { name: 'userManage', title: '👥  Users',          className: 'tab-users' },
        ]}
      >
        {tab => {
          switch (tab.name) {
            case 'newUsers':   return <NewUserRegistrationTab />;
            case 'adminEmail': return <AdminEmailSettingTab />;
            case 'translations': return <TranslationsTab />;
            case 'notify':     return <NotificationTab />;
            case 'userManage': return <UserManagementTab />;
            default:           return <GeneralSettingTab />;
          }
        }}
      </TabPanel>
    </div>
  </ToastProvider>
);

export default App;
